<template>
	<v-container fluid class="ma-0 pa-0 pl-12">
		<v-col class="ma-0 pa-0" cols="12" id="head_title">
			<v-col class="pa-0" cols="12" id="main_content">
				<v-row class="ma-0 pa-0" align="center" id="header_height">
					<router-link :to="{ path: '/setting' }"
						style="color:transparent;">
						<v-col class="ma-0 pa-0" cols="auto" align="center"
							style="color:#08B0FF;font-size:1rem;text-align:center;">
							{{ts('title')}}
						</v-col>
					</router-link>
					<v-img max-height="100%" max-width="1.5rem" class="ma-0 pa-0 mr-3"
						src="@/assets/images/history_arrow.png"></v-img>
					<router-link :to="{ path: '/setting/authority' }"
						style="color:transparent;">
						<v-col class="ma-0 pa-0" cols="auto" align="center"
							style="color:#08B0FF;font-size:1rem;text-align:center;">
							{{ts('shareUserPermissionSettings')}}
						</v-col>
					</router-link>
					<v-img max-height="100%" max-width="1.5rem" class="ma-0 pa-0 mr-3"
						src="@/assets/images/history_arrow.png"></v-img>
					<v-col class="ma-0 pa-0" cols="auto">
						{{ts('mappingUserStoreGroup')}}
					</v-col>
				</v-row>
			</v-col>
		</v-col>
    <v-col class="pa-0" id="main_content" cols="12" align="center">
			<v-col class="ma-0 pa-0 pt-9 mb-15" cols="10" align="left">
				<v-data-table
          :items="records"
          :items-per-page="itemsPerPage"
          fixed-header
          height="70vh"
          class="elevation-1 fixed-table"
          dark
          :footer-props="{
            itemsPerPageOptions: [100, -1],
          }">
          <template v-slot:header="{}">
            <thead>
              <tr>
                <th v-for="header in headers" :key="header.value" :class="header.value === 'userName' ? 'sticky-column' : ''">
                  {{ header.text }}
                </th>
              </tr>
            </thead>
          </template>
          <template v-slot:item="{ item }">
            <tr>
              <td class="sticky-column">
                <v-row class="pl-2">{{ item.userName }}</v-row>
                <v-row class="pl-2">{{ item.name }}</v-row>
              </td>
              <td v-for="(value, key) in item.storeGroups" :key="key">
                <v-switch :input-value="value" @change="toggleStoreGroup(item, key)" light></v-switch>
              </td>
            </tr>
          </template>
        </v-data-table>
        <v-row align="center" justify="end">
          <v-btn width="auto" height="2rem" id="blue_btn" :loading="saveLoading"
            class="blue_btn ma-0 pa-0 mt-10 mr-3" elevation="0" @click="save()">
            {{t('save')}}
          </v-btn>
        </v-row>
			</v-col>
		</v-col>
    <v-progress-circular
      indeterminate
      v-if="dataLoading"
    ></v-progress-circular>
	</v-container>
</template>

<script>
import mixin from '@/mixin';

export default {
	components: {
		
	},
	mixins: [mixin.common],
	data: () => ({
    headers: [],
    records: [],  
    users: {},
    mappings: {},
    initData: [],
    itemsPerPage: 100,
    dataLoading: false,
    saveLoading: false,
    updateIds: []
	}),
  mounted() {
    // 세로 열에 등록된 모든 사용자(일반 사용자, 시청자), 가로 열에 등록된 모든 점포 그룹을 표시한다
    // 최신 상태의 records를 가져옴
    this.setData();
  },
	methods: {
    ts(t) {
      return this.$t("lang.settings." + t);
    },
    tc(t) {
      return this.$t("lang.common." + t);
    },
    async setData() {
      this.dataLoading = true;
      const userDetail = this.$store.getters.getUserDetail;
      const unisCustomerCd = userDetail.unisCustomerCd;
      if (!unisCustomerCd) {
        this.dataLoading = false;
        this.showToastMessage(this.tmb('requestFail'));
        return;
      }
      const usersRes = await this.networkController.getShareUser({}, unisCustomerCd);
      const mappingRes = await this.networkController.getBatchSharedUserStoreGroup({});
      this.users = usersRes.data.accounts;
      this.mappings = mappingRes.data;
      
      this.setHeader();
      this.setMapping();
      this.dataLoading = false;
    },
    setHeader() {
      this.headers = [{ text: this.tc('userId'), value: 'userName', sortable: true, width: '6rem' }];
      this.mappings.forEach(item => {
        this.headers.push({
          text: item.groupName,
          value: `storeGroups.${item.id}`,
          sortable: false,
        });
      });
    },
    setMapping() {
      console.log("Users", this.users);
      const initStoreGroupMap = {};
      this.mappings.forEach(item => {
        initStoreGroupMap[item.id] = false;
      });
      this.users.forEach(user => {
        const record = {
          userName: user.userName,
          name: user.name,
          mailAddress: user.mailAddress,
          umid: user.umid,
          storeGroups: { ...initStoreGroupMap }
        };
        // 점포그룹 매핑은 일반사용자와 뷰어만 가능
        if (this.isUserOrViewer(user.role)) {
          this.records.push(record);
        }
      });
      this.setUserStoreGroup();
      this.initData = JSON.parse(JSON.stringify(this.records));
    },
    setUserStoreGroup() {
      console.log("Mapping", this.mappings);
      this.mappings.forEach(item => {
        if (item.sharedUserStoreGroups.length > 0) {
          item.sharedUserStoreGroups.forEach(storeGroup => {
            const userRecord = this.records.find(record => record.umid === storeGroup.umid);
            if (userRecord) {
              userRecord.storeGroups[item.id] = true;
            }
          });
        }
      });
    },
    toggleStoreGroup(item, key) {
      item.storeGroups[key] = !item.storeGroups[key];
      this.updateIds.push(item.umid);
    },
    save() {
      this.saveLoading = true;

      const updateMap = {};
      const deleteIds = [];
      const sharedUserStoreGroups = [];
      const updateList = this.records.filter(record => Array.from(new Set(this.updateIds)).includes(record.umid));
      updateList.forEach(record => {
        const initRecord = this.initData.find(initRecord => initRecord.umid === record.umid);
        if (initRecord) {
          Object.keys(record.storeGroups).forEach(key => {
            if (record.storeGroups[key] !== initRecord.storeGroups[key]) {
              if (record.storeGroups[key]) {
                sharedUserStoreGroups.push({
                  name: record.name,
                  mailAddress: record.mailAddress,
                  umid: record.umid,
                  storeGroupId: key
                });
              } else {
                this.mappings.find(item => item.id === key).sharedUserStoreGroups.forEach(storeGroup => {
                  if (storeGroup.umid === record.umid) {
                    deleteIds.push(storeGroup.id);
                  }
                });
              }
            }
          });
        }
      });

      updateMap.deleteIds = deleteIds;
      updateMap.sharedUserStoreGroups = sharedUserStoreGroups;
      this.networkController.postBatchSharedUserStoreGroup(updateMap);

      this.saveLoading = false;

      this.$dialog.confirm({
				text: this.ts('registerCompleted'),
				actions: {
					true: {
						color: 'white', text: this.t('confirm'),
						handle: () => {
							this.$router.push({ path: '/setting/authority' });
						}
					}
				}
			});
    }
	}
}
</script>

<style lang="scss" scoped>
#header_text {
  font-size: 1.5rem;
  text-align: left;
}
#header_divider {
	border: 1px solid rgb(141, 141, 141);
}
.blue_btn {
	background-color: #008DD0 !important;
	color: white;
	border-radius: 4px;
	min-width: 6rem !important;
}
.custom-scrollbar ::-webkit-scrollbar {
  height: 3px;
}
.custom-scrollbar ::-webkit-scrollbar-thumb {
  background-color: white;
}
.custom-scrollbar ::-webkit-scrollbar-track {
  background-color: #4A4A4A;
}
::v-deep .v-data-table__wrapper tbody tr {
  background-color: inherit !important; /* 기본 배경 색상 유지 */
}
::v-deep .v-data-table__wrapper tbody tr:hover {
  background-color: inherit !important; /* 마우스 오버 시 배경색 변하지 않게 */
}
.fixed-table .v-data-table__wrapper {
  overflow-x: auto;
}
.fixed-table thead th {
  position: sticky;
  top: 0;
  background-color: #1E1E1E;
  z-index: 2; /* 내용물보다 위에 표시되도록 */
}

.fixed-table tbody td.sticky-column {
  position: sticky;
  left: 0;
  background-color: #1E1E1E;
  z-index: 3;
}
.fixed-table thead th.sticky-column {
  position: sticky;
  left: 0;
  background-color: #1E1E1E;
  z-index: 4;
}
</style>